// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"46a7dd27","12":"907b8d45"}[chunkId] + ".chunk.js";
};